import { Component, Inject, OnInit } from '@angular/core';
import {
	MAT_DIALOG_DATA,
	MatDialogRef,
	MatDialogClose,
	MatDialogActions,
} from '@angular/material/dialog';
import {
	AbstractControl,
	UntypedFormBuilder,
	UntypedFormGroup,
	Validators,
	ReactiveFormsModule,
} from '@angular/forms';
import { Observable } from 'rxjs';
import { MatSelectChange, MatSelect } from '@angular/material/select';
import { AuUtilsFunctions } from '@app/shared';
import { IBuilding, IBuildingFloor } from '@shared/interfaces/building.interfaces';
import { MatIcon } from '@angular/material/icon';
import { MatRipple, MatOption, MatOptgroup } from '@angular/material/core';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';

import { AuTechnoBtnComponent } from '../../../shared/ui-components/au-techno-btn/au-techno-btn.component';
import { NgxTolgeeModule } from '@tolgee/ngx';

export interface EditLocationData {
	buildings: IBuilding[];
	buildingId: string;
	currentLocationId: string;
}

@Component({
	templateUrl: './edit-location.component.html',
	styleUrls: ['./edit-location.component.scss'],
	imports: [
		MatIcon,
		MatDialogClose,
		MatRipple,
		ReactiveFormsModule,
		MatFormField,
		MatLabel,
		MatSelect,
		MatOption,
		MatError,
		MatOptgroup,
		MatDialogActions,
		AuTechnoBtnComponent,
		NgxTolgeeModule,
	],
})
export class EditLocationModalComponent implements OnInit {
	locationFormGroup: UntypedFormGroup;

	filteredLocationOptions: Observable<IBuilding[]>;
	locations: IBuilding[] = [];

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: EditLocationData,
		private dialogRef: MatDialogRef<any>,
		private fb: UntypedFormBuilder
	) {
		this.locations = AuUtilsFunctions.deepCopyObject(data.buildings);
	}

	ngOnInit() {
		this.prepareForm();
	}

	prepareForm() {
		this.locationFormGroup = this.fb.group({
			building: [{ value: this.data.buildingId, disabled: true }],
			room: [this.data.currentLocationId, Validators.required],
		});
	}

	getBuildingFloors(): IBuildingFloor[] {
		const building = this.locations.find(
			location => location.id === this.buildingControl.value
		);
		return building.floor;
	}

	toggleBuildingControl() {
		if (this.buildingControl.enabled) {
			this.buildingControl.disable();
		} else {
			this.buildingControl.enable();
		}
	}

	onBuildingChange(item: MatSelectChange): void {
		if (item.value) {
			this.roomControl.reset('');
		}
	}

	save() {
		this.dialogRef.close(this.roomControl.value);
	}

	get buildingControl(): AbstractControl {
		return this.locationFormGroup.controls.building;
	}

	get roomControl(): AbstractControl {
		return this.locationFormGroup.controls.room;
	}
}
